import authReducer from "./authReducer";
import registrationReducer from "./registrationReducer";
import newLecturerReducer from "./newLecturerReducer";

const iamReducers = {
    auth: authReducer,
    registration: registrationReducer,
    newLecturer: newLecturerReducer
}

export default iamReducers;